import { render, staticRenderFns } from "./card-product-specs-cmp.vue?vue&type=template&id=85eb22c4&scoped=true"
import script from "./card-product-specs-cmp.vue?vue&type=script&lang=js"
export * from "./card-product-specs-cmp.vue?vue&type=script&lang=js"
import style0 from "./card-product-specs-cmp.vue?vue&type=style&index=0&id=85eb22c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eb22c4",
  null
  
)

export default component.exports